const products = [
  {
    name: "GRUNDAL VPN",
    tagline: "Privacy & Security",
    description:
      "A powerful VPN solution built for iOS that encrypts your internet connection, masks your IP address, and keeps your online activity completely private. Designed for speed and reliability.",
    features: ["256-bit AES Encryption", "No-Log Policy", "Global Server Network", "Kill Switch"],
    image:
      "https://public.readdy.ai/ai/img_res/2c36a3306ed0924c3c15de927a9dc693.jpg",
    accent: "from-gray-900 to-gray-800",
    textLight: true,
  },
  {
    name: "GRUNDAL Cleaner",
    tagline: "Performance & Optimization",
    description:
      "An intelligent iOS cleaner that removes junk files, optimizes storage, and keeps your device running smoothly. Reclaim space and boost performance with a single tap.",
    features: ["Smart Junk Removal", "Duplicate Finder", "Memory Boost", "Battery Optimizer"],
    image:
      "https://readdy.ai/api/search-image?query=phone%20cleaner%20optimization%20app%20on%20iPhone%2C%20clean%20white%20interface%20with%20green%20progress%20circles%2C%20storage%20management%20dashboard%2C%20minimalist%20UI%20design%2C%20bright%20and%20fresh%20aesthetic%2C%20high%20quality%20product%20mockup&width=600&height=700&seq=cleaner001&orientation=portrait",
    accent: "from-gray-50 to-gray-100",
    textLight: false,
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-gray-400 font-medium mb-4">
            Our Products
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Built for iOS. Built for You.
          </h2>
          <p className="mt-4 text-gray-500 text-lg max-w-xl mx-auto">
            Two flagship applications designed to protect your privacy and optimize your device.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-product-shop>
          {products.map((product) => (
            <div
              key={product.name}
              className={`rounded-3xl overflow-hidden bg-gradient-to-br ${product.accent} transition-transform duration-300 hover:scale-[1.01]`}
            >
              {/* Image */}
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                <p
                  className={`text-xs uppercase tracking-[0.2em] font-medium mb-2 ${
                    product.textLight ? "text-white/50" : "text-gray-400"
                  }`}
                >
                  {product.tagline}
                </p>
                <h3
                  className={`text-2xl font-bold mb-3 ${
                    product.textLight ? "text-white" : "text-gray-900"
                  }`}
                >
                  {product.name}
                </h3>
                <p
                  className={`text-sm leading-relaxed mb-6 ${
                    product.textLight ? "text-white/70" : "text-gray-500"
                  }`}
                >
                  {product.description}
                </p>

                {/* Feature Tags */}
                <div className="flex flex-wrap gap-2">
                  {product.features.map((f) => (
                    <span
                      key={f}
                      className={`text-xs px-3 py-1.5 rounded-full font-medium ${
                        product.textLight
                          ? "bg-white/10 text-white/80"
                          : "bg-white text-gray-600 border border-gray-200"
                      }`}
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
